module.exports = __webpack_public_path__ + "static/media/T4.fd738735.jpg";